<!-- Notifications component template -->
<div class="notifications-container">
    <!-- Notifications content will go here -->
</div>
